"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyNodeMapper = void 0;
const jsonapi_utils_1 = require("../../../#core/jsonapi-utils");
class TaxonomyNodeMapper {
    toTaxonomyNode(taxonomyNodeResource) {
        return {
            id: taxonomyNodeResource.id,
            createdAt: new Date(taxonomyNodeResource.attributes.createdAt),
            updatedAt: new Date(taxonomyNodeResource.attributes.updatedAt),
            classId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeResource.relationships.class),
            parentId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeResource.relationships.parent),
            taxonomyId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeResource.relationships.taxonomy),
        };
    }
    toTaxonomyNodeResource(taxonomyNode) {
        return {
            id: taxonomyNode.id,
            type: 'TaxonomyNode',
            attributes: {
                createdAt: taxonomyNode.createdAt.toISOString(),
                updatedAt: taxonomyNode.updatedAt.toISOString(),
            },
            relationships: {
                class: jsonapi_utils_1.createRelationship(taxonomyNode.classId, (id) => ({ type: 'Class', id })),
                parent: jsonapi_utils_1.createRelationship(taxonomyNode.parentId, (id) => ({ type: 'TaxonomyNode', id })),
                taxonomy: jsonapi_utils_1.createRelationship(taxonomyNode.taxonomyId, (id) => ({ type: 'Taxonomy', id })),
            },
        };
    }
    toTaxonomyNodeCreation(taxonomyNodeCreationResource) {
        return {
            classId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeCreationResource.relationships.class),
            parentId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeCreationResource.relationships.parent),
            taxonomyId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeCreationResource.relationships.taxonomy),
        };
    }
    toTaxonomyNodeCreationResource(taxonomyNodeCreation) {
        return {
            type: 'TaxonomyNode',
            relationships: {
                class: jsonapi_utils_1.createRelationship(taxonomyNodeCreation.classId, (id) => ({ type: 'Class', id })),
                parent: jsonapi_utils_1.createRelationship(taxonomyNodeCreation.parentId, (id) => ({ type: 'TaxonomyNode', id })),
                taxonomy: jsonapi_utils_1.createRelationship(taxonomyNodeCreation.taxonomyId, (id) => ({ type: 'Taxonomy', id })),
            },
        };
    }
    toTaxonomyNodeUpdate(taxonomyNodeUpdateResource) {
        return {
            id: taxonomyNodeUpdateResource.id,
            parentId: jsonapi_utils_1.pluckRelationshipId(taxonomyNodeUpdateResource.relationships.parent),
        };
    }
    toTaxonomyNodeUpdateResource(taxonomyNodeUpdate) {
        return jsonapi_utils_1.normalizeResource({
            id: taxonomyNodeUpdate.id,
            type: 'TaxonomyNode',
            relationships: {
                parent: jsonapi_utils_1.createRelationship(taxonomyNodeUpdate.parentId, (id) => ({ type: 'TaxonomyNode', id })),
            },
        });
    }
}
exports.TaxonomyNodeMapper = TaxonomyNodeMapper;
//# sourceMappingURL=#taxonomy-node-mapper.js.map